import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography } from '@mui/material';
import { TextButton, LoadingButton } from '../../common/StyledButtons';
import { STANDARD_PARAGRAPH_STYLE } from '../../../constants/Styles';
import { getUserId } from '../../../selectors/UserSelectors';
import { NOTIFICATION_TYPE, showNotificationBar } from '../../../actions/error-pages/NotificationBarActions';
import { createNewStripeCustomer } from '../../../clients/bettercallkyle/BckApi';
import { getSiteByIdForUser } from '../../../actions/internal/SiteActions';

const AdminCreateStripeCustomerModal = ({ open, onClose, site }) => {

    const [isCreatingUser, setIsCreatingUser] = useState(false);

    const handleCreateStripeAccount = async () => {
        try {
            setIsCreatingUser(true);
            if (!site) throw new Error("No site available.");
            if (!site.site_security.accessible_users || site.site_security.accessible_users.length === 0) throw new Error("No users attached to site.");

            const primaryUser = site.site_security.accessible_users.find(u => u.is_primary_user);
            if (!primaryUser) throw new Error("No primary user found");

            const user_id = getUserId();

            await createNewStripeCustomer(user_id, site.site_id, primaryUser.email);
            await getSiteByIdForUser(site.site_id, user_id, true);

            handleClose();

            showNotificationBar(NOTIFICATION_TYPE.SUCCESS, `Created new Stripe customer account for business.`)
        } catch(ex) {
            showNotificationBar(NOTIFICATION_TYPE.ERROR, `Could not create Stripe account for busienss. Details: ${ex}`)
        } finally {
            setIsCreatingUser(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={open} fullWidth maxWidth="sm">
        <DialogTitle>
            <h4 style={{ margin: 0, padding: 0 }}>Create Stripe Account</h4>
        </DialogTitle>
        <DialogContent>
            <Box sx={{ paddingTop: 1 }}>
            <p style={ STANDARD_PARAGRAPH_STYLE }>This will create a new Stripe account for <strong>{site ? site.site_details.site_name : 'this business'}</strong> and attach it to this business account.</p>
            </Box>
        </DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '16px' }}>
            <TextButton onClick={handleClose}>Cancel</TextButton>
            <LoadingButton onClick={handleCreateStripeAccount} isLoading={isCreatingUser}>Create</LoadingButton>
        </Box>
        </Dialog>
    );
};

export default AdminCreateStripeCustomerModal;